<template lang="pug">
  div(
    v-if="pdfByteArray"
    class="pdf-wrapper"
  )
    m-pdf-viewer(
      type="templates"
      :src="pdfByteArray"
      :item="template"
    )
</template>

<script>
import Base64js from 'base64-js'
import Gallery from '~/modules/templates/models/Gallery'
import MPdfViewer from '~/components/modules/m-pdf-viewer.vue'

export default {
  name: 'BlockTemplatesGalleryView',
  components: { MPdfViewer },
  props: {
    templateId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      name: null,
      loading: false
    }
  },
  computed: {
    // todo
    model() {
      return Gallery
    },
    template() {
      return this.model.query().whereId(this.templateId).first()
    },
    pdfByteArray() {
      if (!this.template) {
        return
      }
      const pdfBase64 = this._.get(this.template, 'fileContent', null)
      if (pdfBase64) {
        return Base64js.toByteArray(pdfBase64)
      }
      return null
    }
  },
  created() {
    this.getTemplate()
  },
  methods: {
    async getTemplate() {
      await Gallery.api().read(this.templateId)
    }
  }
}
</script>

<style scoped lang="scss">
.pdf-wrapper {
  display: flex;
  justify-content: center;
}
</style>
